<div class="m-4">
  <div class="buttonLeiste">Videoanleitungen</div>
  <div class="mt-2 schmal" style="background-color: white">
    <kendo-treeview
      [nodes]="erg()"
      textField="bezeichnung"
      kendoTreeViewExpandable
      [children]="fetchChildren"
      [hasChildren]="hasChildren"
      (nodeClick)="onNodeClick($event)"
      [expandBy]="'id'"
      [expandedKeys]="expandedKeys()"
    >
      <ng-template kendoTreeViewNodeTemplate let-node>
        <span [ngClass]="{ 'leaf-node': !hasChildren(node) }">{{ node.bezeichnung }}</span>
      </ng-template>
    </kendo-treeview>
  </div>

  @if (videoUrl()) {
    <div class="mt-3 schmal">
      <video width="960" height="540" controls [src]="sanitizer.bypassSecurityTrustResourceUrl(videoUrl())" autoplay="true"></video>
    </div>
  }
</div>
